import React from "react";

export const PageBreak = () => <div style={{ pageBreakAfter: "always" }} />;
